import { useState } from 'react';
import { Button } from 'react-bootstrap';

// v3_fix_issues.md #4 - filters shown inline on a wide screen, behind a "Filters" toggle on
// mobile. `children` (the filter form/row) is rendered exactly once, in a container that is
// visible on lg+ always, and on smaller screens only while toggled open.
export default function CollapsibleFilters({ children, label = 'Filters', className = '', defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={className}>
      <Button
        variant="outline-secondary"
        size="sm"
        className="mb-2 d-lg-none d-inline-flex align-items-center gap-1"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span aria-hidden="true">⚲</span>
        {open ? `Hide ${label.toLowerCase()}` : label}
      </Button>
      <div className={open ? '' : 'd-none d-lg-block'}>{children}</div>
    </div>
  );
}
